export enum UserRole {
  ROLE_PERSONAL = 'ROLE_PERSONAL',
  ROLE_BUSINESS = 'ROLE_BUSINESS',
  ROLE_BUSINESS_PLUS = 'ROLE_BUSINESS_PLUS',
  ROLE_BUSINESS_EXP = 'ROLE_BUSINESS_EXP',
  ROLE_BUSINESS_PLUS_EXP = 'ROLE_BUSINESS_PLUS_EXP',
  ROLE_ADMIN = 'ROLE_ADMIN',
}

export class UserRoleFactory {
  static allRoles(): UserRole[] {
    return Object.values(UserRole);
  }

  static expiredRoles(): UserRole[] {
    return [
      UserRole.ROLE_BUSINESS_EXP,
      UserRole.ROLE_BUSINESS_PLUS_EXP,
    ];
  }

  static companyRoles(): UserRole[] {
    return [
      UserRole.ROLE_BUSINESS_EXP,
      UserRole.ROLE_BUSINESS,
      UserRole.ROLE_BUSINESS_PLUS,
      UserRole.ROLE_BUSINESS_PLUS_EXP,
    ];
  }

  static customerRoles(): UserRole[] {
    return [
      UserRole.ROLE_PERSONAL,
    ];
  }
}
